const checkReference = (locationUrl: string): string => {
  const operation: boolean = locationUrl.includes('reference')
  let res = ''

  if (operation) {
    const referenceStr: string[] | null = locationUrl.match(/[&]reference=[\d]*/)
    res = referenceStr ? referenceStr[0].replace(/\D/g, '') : ''
  }

  return res
}

export default checkReference
